import { useLocalSearchParams } from 'expo-router';
import { WorldCupGroupCreatedScreen } from '../../../../components/worldcup/WorldCupGroupCreatedScreen/WorldCupGroupCreatedScreen';
import type { CrestColorId, CrestEmblemId } from '../../../../components/worldcup/CreateWorldCupGroupScreen/CreateWorldCupGroupScreen.constants';

export default function WorldCupGroupCreatedRoute() {
  const { groupId, inviteCode, groupName, crestColor, crestEmblem, description, entryFeeCoins } =
    useLocalSearchParams<{
      groupId: string;
      inviteCode: string;
      groupName: string;
      crestColor: string;
      crestEmblem: string;
      description: string;
      entryFeeCoins: string;
    }>();

  return (
    <WorldCupGroupCreatedScreen
      groupId={groupId ?? ''}
      inviteCode={inviteCode ?? ''}
      groupName={groupName ?? ''}
      crestColor={(crestColor ?? 'purple') as CrestColorId}
      crestEmblem={(crestEmblem ?? 'trophy') as CrestEmblemId}
      description={description ?? ''}
      entryFeeCoins={Number(entryFeeCoins ?? '0')}
    />
  );
}
